module.exports = (__parcel__import__("eeVeW")).then(() => parcelRequire('fyWP3'));